module.exports = __webpack_public_path__ + "static/media/dental_icon_two.850f0b33.svg";